import { Loader } from 'modules/Loader';
import { Checkbox } from 'modules/Toggles';
import { MenuItem } from './MenuItem';
import { CheckboxContainer, IconContainer } from './styled';
export function MenuItemCheckbox(props) {
    const { children, checked, disabled, loading, onChange, closeOnClick } = props;
    const handleChange = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    const handleCheckboxClick = (event) => {
        event.stopPropagation();
    };
    const handleItemClick = () => {
        if (disabled) {
            return undefined;
        }
        return onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    return (<MenuItem disabled={disabled || loading} onClick={handleItemClick} closeOnClick={closeOnClick}>
      <CheckboxContainer data-checked={checked}>
        <Checkbox checked={checked} disabled={disabled} onClick={handleCheckboxClick} onChange={handleChange}/>
      </CheckboxContainer>

      {children}

      {loading && (<IconContainer>
          <Loader size="xs"/>
        </IconContainer>)}
    </MenuItem>);
}
